import { Component, Inject } from '@angular/core';

import { ToolboxComponent } from '../toolbox.component';
import { ToolboxService } from '../toolbox.service';

@Component({
    selector: 'product-chooser-toolbox',
    templateUrl: './product-chooser-toolbox.component.html',
    styleUrls: [
        './product-chooser-toolbox.component.scss',
        '../toolbox.component.scss'],
    standalone: false
})
export class ProductChooserToolboxComponent extends ToolboxComponent
{
  protected name: string = 'ProductChooserToolbox';

  constructor(
      @Inject(ToolboxService) toolboxService)
  {
    super(toolboxService);
  }
}
